import { render, staticRenderFns } from "./SpecsAction.vue?vue&type=template&id=6fd9c2de&scoped=true"
import script from "./SpecsAction.vue?vue&type=script&lang=js"
export * from "./SpecsAction.vue?vue&type=script&lang=js"
import style0 from "./SpecsAction.vue?vue&type=style&index=0&id=6fd9c2de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd9c2de",
  null
  
)

export default component.exports